import React from 'react';

import './MainContainer.scss';
import AdminNav from './AdminNav';

const MainContainer = ({ children }) => (
  <div className='main-container-outer-container'>
    <AdminNav />
    {children}
  </div>
);

export default MainContainer;
